/**
 * 8th Wall (XR Engine) のロードヘルパ。
 *
 * 前提:
 *   - `npm install @8thwall/engine-binary`
 *   - `npm run copy-8thwall` で node_modules から public/8thwall/ にコピー（postinstall/predev で自動実行）
 *   - index.html に <script src="/8thwall/xr.js" async data-preload-chunks="slam"></script> を含めること
 *
 * 使い方:
 *   const XR8 = await getXR8();
 *   XR8.run({ canvas: ... });
 */

import { XR8Promise } from '@8thwall/engine-binary';

export type XR8Type = Awaited<typeof XR8Promise>;

let resolved: XR8Type | null = null;

export async function getXR8(timeoutMs = 8000): Promise<XR8Type> {
  if (resolved) return resolved;
  const timeout = new Promise<never>((_, reject) => {
    setTimeout(() => reject(new Error('XR8 のロードがタイムアウトしました')), timeoutMs);
  });
  resolved = (await Promise.race([XR8Promise, timeout])) as XR8Type;
  return resolved;
}

export function isXR8Ready(): boolean {
  return resolved !== null;
}
